import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import PopularGrid from './components/PopularGrid';
import StatsSection from './components/StatsSection';
import LatestUpdates from './components/LatestUpdates';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';

const siteUrl = 'http://iitzgd.cn/';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫大全',
    url: siteUrl,
    description: '韩漫网站提供无删减韩漫大全和好看的韩国漫画，免费下拉式观看模式操作便捷且自动加载，让您沉浸于连贯阅读流程中。',
    logo: `${siteUrl}/logo.png`,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@iitzgd.cn',
    },
    sameAs: ['http://iitzgd.cn/'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫大全',
    url: siteUrl,
    description: '无删减韩漫大全，好看的韩国漫画免费下拉式观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫大全 - 首页',
    url: siteUrl,
    description: '访问韩漫网站探索无删减韩漫大全和好看的韩国漫画，免费下拉式观看模式操作便捷且自动加载。',
    isPartOf: {
      '@type': 'WebSite',
      name: '韩漫大全',
      url: siteUrl,
    },
    inLanguage: 'zh-CN',
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫网站-无删减韩漫大全_好看的韩国漫画_免费漫画下拉式观看"
        description="访问韩漫网站探索无删减韩漫大全和好看的韩国漫画，免费下拉式观看模式操作便捷且自动加载，让您沉浸于连贯阅读流程中。每日更新，海量资源，高清画质。"
        keywords="韩漫网站,无删减韩漫大全,好看的韩国漫画,免费漫画下拉式观看,韩国漫画中文,韩漫在线观看"
        canonicalUrl={siteUrl}
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20hero%20banner%2C%20collection%20of%20beautiful%20Korean%20comic%20covers%20arranged%20artistically%2C%20warm%20lighting%2C%20reading%20atmosphere%2C%20professional%20editorial%20layout&width=1200&height=630&seq=og-home&orientation=landscape"
        ogType="website"
        schemaData={homeSchema}
      />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryNav />
          <PopularGrid />
          <StatsSection />
          <LatestUpdates />
          <ArticleSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}
